// src/components/SearchBar.js
import React, { useState, useEffect } from 'react';
import './SearchBar.css'; // Import the CSS for the search bar

const SearchBar = ({ onSearchSubmit, initialQuery = '', size = 'standard', className = '' }) => {
  const [query, setQuery] = useState(initialQuery);

  // Update internal query state if initialQuery prop changes
  // This is useful if the parent component wants to update the search bar's content
  // (e.g., when navigating directly to a search results page, setting the bar from URL query)
  useEffect(() => {
    setQuery(initialQuery);
  }, [initialQuery]);

  const handleChange = (event) => {
    setQuery(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (query.trim() === '') {
      alert('Please enter a search term.');
      return;
    }
    if (onSearchSubmit) {
      onSearchSubmit(query.trim());
    }
  };

  return (
    <form onSubmit={handleSubmit} className={`search-form ${className}`}>
      <input
        type="text"
        placeholder="Search for podcasts..."
        value={query}
        onChange={handleChange}
        className={`search-input ${size === 'large' ? 'search-input--large' : ''}`}
      />
      <button type="submit" className="search-button">
        {/* You can use an SVG search icon here for a more Google-like feel */}
        Search
      </button>
    </form>
  );
};

export default SearchBar;